import api, { twUrl } from '../../utils/api';
import { CreateUserRequest, EditUserRequest, UserResponse } from './User.model';
import { BaseQueryParams } from '../Global.model';

class UserService {
  static getUsers(
    queryParams?: BaseQueryParams
  ): Promise<{ content: UserResponse[]; totalItems: number }> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.users, {
        params: queryParams
      });

      apiResponse
        .then((response: any) => {
          const data = {
            content: response.data.data,
            totalItems: response.data.count
          };
          resolve(data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  static findByEmail(email: string): Promise<UserResponse | null> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.findUserByEmail(email));
      apiResponse
        .then((response: any) => resolve(response.data?.data))
        .catch((error: any) => {
          if (error.response.status === 404) {
            resolve(null);
          }
          reject(error.response.data);
        });
    });
  }

  static invite(userId: string): Promise<UserResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.inviteUser, {
        userId
      });

      apiResponse
        .then((response: any) => resolve(response.data.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  static disable(userId: string): Promise<UserResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.delete(twUrl.disableUser(userId));

      apiResponse
        .then((response: any) => resolve(response.data.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  static create(body: CreateUserRequest): Promise<UserResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.post(twUrl.createUser, body);
      apiResponse
        .then((response: any) => resolve(response.data))
        .catch((error) => reject(error.response.data));
    });
  }

  static editUser(userId: string, body: EditUserRequest): Promise<UserResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.editUser(userId), body);

      apiResponse
        .then((response: any) => resolve(response.data.data))
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
}

export default UserService;
